export const fontSemiBold = {
    fontFamily: "Vazirmatn",
    fontWeight: 700,
};